module.exports = __webpack_public_path__ + "img/var_03_step3@2x.defca017.jpg";